<template>
  <div class="page-home">
    <div class="g-wrap news-wrap">
      <column-header2 :data="newsColumn"></column-header2>
      <div class="column-wrap">
        <ic-slide-news :data="slideNews"></ic-slide-news>
        <ic-news :data="topNews" type="calendar"></ic-news>
      </div>
    </div>
    <div class="show-wrap">
      <div class="g-wrap">
        <column-header2 :data="showColumn"></column-header2>
        <div class="column-wrap">
          <show-card v-for="item in showList" :data="item" :key="item.id"></show-card>
        </div>
      </div>
    </div>
    <div class="support-expert">
      <div class="g-wrap ">
        <column-header2 :data="{ name: '成果专家', link: `show/expert/list` }"></column-header2>
        <div class="column-wrap">
          <expert-card v-for="item in expertList" :data="item" :key="item.id"></expert-card>
        </div>
      </div>
    </div>
    <div class="support-research">
      <div class="g-wrap ">
        <column-header2 :data="{ name: '科研单位', link: `show/research/list` }"></column-header2>
        <div class="column-wrap">
          <research-card v-for="item in researchList" :data="item" :key="item.id"></research-card>
          <!-- <expert-card v-for="item in researchList" :data="item" :key="item.id"></expert-card> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResearchCard from "./research/card";
import ShowCard from "./components/ShowCard";
import ColumnHeader from "_c/ColumnHeader2";
import ExpertCard from "./expert/card";
import SlideNews from "_c/SlideNews";
import News from "_c/News";
import { getData } from "api/app";
import { mapState } from "vuex";

// const showLinkDecorator = item => {
//   item.link = this.$subsitePrefix+`/achievement/show-detail/${item.name}?id=${item.id}`;
//   return item;
// };
export default {
  name: "panel-show",
  data() {
    return {
      newsColumn: {
        name: "成果转化政策",
        link: this.$subsitePrefix + "/achievement/policy-list/AchievementPolicy"
      },
      showColumn: {
        name: "成果展示",
        link: this.$subsitePrefix + "/achievement/show-list/Achievement"
      },
      slideNews: [],
      topNews: [],
      showList: [],
      expertList: [],
      researchList: []
    };
  },
  computed: {
    ...mapState("college", ["collegeData"])
  },
  created() {
    this.init();
  },
  components: {
    [ColumnHeader.name]: ColumnHeader,
    [SlideNews.name]: SlideNews,
    [News.name]: News,
    [ShowCard.name]: ShowCard,
    [ExpertCard.name]: ExpertCard,
    ResearchCard
  },
  methods: {
    loadSlideNews() {
      const linkDecorator = item => {
        item.link =
          this.$subsitePrefix +
          `/achievement/policy-detail/AchievementPolicy?id=${item.Id}`;
        return item;
      };
      const queryParams = [
        { Key: "Illustration", Value: "", CompareType: "NotEqualTo" }
      ];
      queryParams.push({
        Key: "College",
        Value: this.collegeData.cid,
        CompareType: "EqualTo"
      });
      getData({ name: "AchievementPolicy", top: 5, params: queryParams })
        .then(res => {
          this.slideNews = (res || []).map(linkDecorator);
        })
        .catch(err => {
          console.log(err);
        });
    },
    loadTopNews() {
      const linkDecorator = item => {
        item.link =
          this.$subsitePrefix +
          `/achievement/policy-detail/AchievementPolicy?id=${item.Id}`;
        return item;
      };
      let params = [
        { Key: "College", Value: this.collegeData.cid, CompareType: "EqualTo" }
      ];
      getData({ name: "AchievementPolicy", top: 8, params })
        .then(res => {
          this.topNews = (res || []).map(linkDecorator);
        })
        .catch(err => {
          console.log(err);
        });
    },
    loadData() {
      this.loadSlideNews();
      this.loadTopNews();
      let params = [
        { Key: "College", Value: this.collegeData.cid, CompareType: "EqualTo" }
      ];
      getData({ name: "achievement", top: 6, params })
        .then(res => {
          this.showList = res || [];
        })
        .catch(err => {
          console.log(err);
        });

      getData({ name: "SchoolExpert", top: 6, params })
        .then(res => {
          this.expertList = res || [];
        })
        .catch(err => {
          console.log(err);
        });
      getData({ name: "Scientific", top: 6, params })
        .then(res => {
          this.researchList = res || [];
        })
        .catch(err => {
          console.log(err);
        });
    },
    init() {
      this.id = this.$route.query.id;
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.column-wrap {
  display: flex;
  flex-wrap: wrap;
}
.news-wrap {
  padding-bottom: 40px;
  .comp-slide-news {
    width: 376px;
    margin-right: 24px;
    height: 266px;
  }
  ::v-deep .comp-news {
    width: 776px;
    height: 266px;
    li {
      width: 299px;
      &:nth-child(2n) {
        margin-left: 24px;
      }
    }
    .comp-news--calendar {
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
    }
  }
}
.show-wrap {
  background-color: #f6f6f9;
  padding-bottom: 16px;
  .column-wrap {
    flex-wrap: wrap;
  }
}
</style>
